if (!customElements.get('cart-note')) {
  class CartDrawerNote extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        trigger: '[data-trigger]',
        wrapper: '[data-wrapper]',
      };
    }

    /**
     * Connected Callback.
     */
    connectedCallback() {
      this.trigger = this.querySelector(this.selectors.trigger);
      this.attachListeners();
    }

    /**
     * Attach Listeners.
     */
    attachListeners() {
      this.trigger.addEventListener('click', this.toggleAccordion.bind(this));
    }

    /**
     * Toggle Accordion.
     * @param {PointerEvent}
     */
    toggleAccordion(e) {
      e.preventDefault();

      this.toggleAttribute('open', !this.hasAttribute('open'));
    }
  }

  customElements.define('cart-note', CartDrawerNote);
}
